import { render, staticRenderFns } from "./dal-comp-go.vue?vue&type=template&id=477050c5"
import script from "./dal-comp-go.vue?vue&type=script&lang=js"
export * from "./dal-comp-go.vue?vue&type=script&lang=js"
import style0 from "./dal-comp-go.vue?vue&type=style&index=0&id=477050c5&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports